import { render, staticRenderFns } from "./OriginForm.vue?vue&type=template&id=3976561f&"
import script from "./OriginForm.vue?vue&type=script&lang=js&"
export * from "./OriginForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports